const global = {
      "defaultSystemName": "Hytera Система позиционирования",
      "alarmHandle": "Тревоги",
      "alarmHandleDescription": "Пожалуйста введите описание",
      "alarmHandleSuccess": "Тревога успешно закрыта",
      "selectTime": "Выбрать время",
      "selectDate": "Выбрать дату",
      "event": "Событие",
      "noramlAlarm": "Нормально",
      "importantAlarm": "Важно",
      "fearfulAlarm": "Критически",
      "processed": "Проверено",
      "undisposed": "Не проверено",
      "showAlarmPosition": "Показать местоположение",
      "fenceAlarm": "Тревога нарушения зоны",
      "today": "Сегодня",
      "lastThreeDays": "Последние 3 дня",
      "lastSevenDays": "Последние 7 дней",
      "lastThirtyDays": "Последние 30 дней",
      "thisWeek": "Эта неделя",
      "thisMounth": "Этот месяц",
      "tomorrow": "Завтра",
      "alarmType": "Тип тревоги",
      "alarmTime": "Время",
      "alarmLevel": "Уровень тревоги",
      "alarmStatu": "Статус тревоги",
      "alarmPosition": "Место",
      "alarmDescription": "Описание",
      "alarmAction": "Действие",
      "totalRecords": "Всего {num} записей",
      "operator": "Оператор",
      "description": "Описание",
      "time": "Время",
      "location": "Местоположение",
      "OK": "OK",
      "slow": "Медленно",
      "verySlow": "Очень медленно",
      "noraml": "Нормально",
      "fast": "Быстро",
      "veryFast": "Очень быстро",
      "noInfo": "Нет информации",
      "trackSearch": "Поиск маршрута",
      "personalTrack": "Персональный маршрут",
      "stayTime": "Длительность",
      "occurAlarm": "Возникновение",
      "reason": "Причина",
      "alarmInfo": "Информация",
      "basicInfo": "Базовая информация",
      "allPoints": "Все точки",
      "stayPoints": "Точки остановки",
      "alarmPoints": "Точки тревоги",
      "movePoints": "Точки движения",
      "inputFliterTip": "Введите значения фильтра",
      "edit": "Изменить",
      "commitSuccess": "Успешно изменено",
      "resetPassword": "Сбросить пароль",
      "oldPassword": "старый пароль",
      "oldPasswordTip": "Введите старый пароль",
      "newPassword": "Новый пароль",
      "newPasswordTip": "Введите новый пароль",
      "confirmPassword": "Подтвердить пароль",
      "confirmPasswordTip": "Введите подтверждение пароля",
      "confirmError": "Пароли не совпадают",
      "resetPasswordSuccess": "Пароль успешно сброшен",
      "upload": "Загрузить",
      "delete": "Удалить",
      "tips": "Напоминание",
      "imgTypeTip": "Введите в формате .png .jpg .jpeg .bmp",
      "imgPngTip": "Пожалуйста, загрузите .png с прозрачным фоновым изображением",
      "imgSizeTip": "Загружаемое изображение не должно превышать 1MB",
      "set": "Установить",
      "none": "Нет",
      "enable": "Включить",
      "disable": "Выключить",
      "loading": "Загрузка",
      "nonsupport": "Не поддерживается",
      "yes": "Да",
      "no": "Нет",
      "forbidIn": "Запрет на вход",
      "forbidOut": "Запрет на выход",
      "call": "Вызов",
      "dispose": "Закрыть",
      "currentOrg": "Текущая",
      "all": "Все",
      "hello": "Привет",
      "logout": "Выход",
      "selectedNum": "Выбрать {num} запись",
      "confirm": "Вы уверены?",
      "create": "Создать",
      "org": "Организация",
      "export": "Экспорт",
      "moreOperation": "Больше операций",
      "second": "Секунда",
      "minute": "минут",
      "detail": "Детали",
      "action": "Действие",
      "cancel": "Отмена",
      "next": "Следующий",
      "pre": "Предыдущий",
      "exportList": "Экспортировать список",
      "deleteConfirm": "Вы уверены?",
      "checkXlsx": "Пожалуйста загрузите файл .xlsx",
      "import": "Импорт",
      "changeBelong": "Изменить",
      "bind": "Связать",
      "unbind": "Отменить связь",
      "absent": "Отсутствует",
      "option": "Опции",
      "track": "Маршрут",
      "fence": "Зона",
      "fingerprint": "Домашняя зона",
      "onAbsent": "Время отсутствия",
      "preAbsent": "Запрос на выход",
      "isRequired": "Требуется данное значение",
      "modify": "Модифицировать",
      "noramlAbsent": "Нормально",
      "helpDocs": "Помощь",
      "download": "Загрузить",
      "deviceDocs": "Документы устройства",
      "systemDocs": "Системные документы",
      "scanQRToDownload": "Отсканировать QR код для загрузки приложения",
      "androidAPPDocs": "Документы android",
      "wxminAppDocs": "Документы WX minapp",
      "scanQRToWXapp": "Пожалуйста используйте WeiXin приложение, отсканируйте QR код и откройте Wxminiapp",
      "status": "Статус",
      "normal": "Завершено",
      "collection": "Сбор данных",
      "terminal": "Терминал",
      "collectFailed": "Сбой сбора данных",
      "chinese": "Китайский язык",
      "english": "Английский язык",
      "russian": "Русский язык", 
      "zxwzfwxt": "Модуль интеллектуального позиционирования",
      "中文":'Китайский язык',
      "英文":'Английский язык',
      "俄语":'Русский язык',
      qsrdz:'Введите адрес',
      passwordLengthTip:'Длина пароля от 6 до 15.',
  很抱歉没有查询到轨迹记录:'Извините, что не проверил траекторию.',
  普管组:"Группа общего управления",
  宽管组:"Широкая трубчатая группа",
  严管组:"Секция строгого управления",
  broadcast:'Трансляция новостей',
  broadcastList:'Список трансляций',
  send:'Передача по радио',
  receiver:'Получатель',
  broadcastTip:'Пожалуйста, введите контент трансляции, длина должна быть в пределах 67 символов, и не используйте специальные символы!',
  broadcastCount:'Количество трансляций',
  broadcastInterval:' Интервал трансляций (секунды)',
  close:'Close',
  total:'Всего',
  people:'Человек',
  sender:'Отправитель',
  content:'Содержание',
  searchTip:'Введите поисковый контент!',
  none:'Нет данных', 
  sendingStatus:'Отправить состояние',
  fscg:'Человек успешно отправляет',
  fssb:'Человек не смог отправить',
  qz:'В том числе',
  yd:'Люди читают',
  read:'Прочитано',
  unread:'Непрочитанные',
  inProgress:'Человек выполняет',
  resend:'Повторить',
  cxfs:'Повторное сообщение успешно! Пожалуйста, проверьте результаты позже.',
  wlbd:'Неудача (колебания сети)',
  zxz:'Выполнено',
  sbzxsb:'Ошибка выполнения устройства',
  cs:'Неудача (тайм - аут)',
  wbdsb:'Ошибка (несвязанное устройство)',
  moveDevice:'Переместить устройство на',
  secondPerTime:'Секунда в минуту',
  timesPerMinute:'В минуту',
  temperature:'℃',
  提示:'Подсказка',
  确认将:'Подтвердить изменение текущей группировки по умолчанию?',
  successful:'Операция прошла успешно',
  secondOnce:'Секунда в раз',
  gpsyx:'GPS включить',
  smtzkg:'Включить сигнал жизни',
  pdjckg:'Включить обнаружение надежности',
  zdjpkg:'Включить автоматическое снижение частоты',
  enableShake:'Включить колебания',
}
export default global
